var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main" },
    [
      _vm.windowIsSmall
        ? _c("div", { ref: "swipeZone", staticClass: "swipe-zone" })
        : _vm._e(),
      _c(
        "ScrollingHeader",
        { attrs: { scrollPosition: 0 } },
        [
          _c(
            "transition",
            { attrs: { mode: "out-in" } },
            [
              _vm.showAppBarsOnScroll
                ? _c("AppBar", {
                    ref: "appBar",
                    staticClass: "app-bar",
                    attrs: {
                      title: _vm.title,
                      showNavigation: _vm.showNavigation,
                      showAppNavView: _vm.isAppContextAndTouchDevice,
                    },
                    on: {
                      toggleSideNav: function ($event) {
                        _vm.navShown = !_vm.navShown
                      },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "sub-nav",
                          fn: function () {
                            return [_vm._t("subNav")]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      true
                    ),
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm.isLoading
            ? _c("KLinearLoader", {
                attrs: { type: "indeterminate", delay: false },
              })
            : _vm._e(),
          _vm._t("storageNotif"),
        ],
        2
      ),
      _c(
        "div",
        {
          staticClass: "main-wrapper",
          style: [_vm.wrapperStyles],
          attrs: { id: "main" },
        },
        [_vm._t("default", null, { pageContentHeight: _vm.pageContentHeight })],
        2
      ),
      _c(
        "transition",
        { attrs: { mode: "out-in" } },
        [
          _vm.showAppBarsOnScroll
            ? _c("SideNav", {
                ref: "sideNav",
                attrs: {
                  navShown: _vm.navShown,
                  showAppNavView: _vm.isAppContextAndTouchDevice,
                },
                on: {
                  toggleSideNav: function ($event) {
                    _vm.navShown = !_vm.navShown
                  },
                  shouldFocusFirstEl: function ($event) {
                    return _vm.findFirstEl()
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }